import { IconButton } from '@/shared/ui/lib/IconButton';
import { SvgIcon } from '@/shared/ui/SvgIcon';

export const EyeVisibilityToggle = ({
  visible,
  onClick,
  disabled,
}: {
  visible: boolean;
  onClick: (event: React.MouseEvent) => void;
  disabled: boolean;
}) => {
  return (
    <IconButton
      onClick={onClick}
      edge="end"
      disabled={disabled}
      variant="icon"
      color="inherit"
    >
      {visible ? (
        <SvgIcon name="password-on" fontSize="small" />
      ) : (
        <SvgIcon name="password-off" fontSize="small" />
      )}
    </IconButton>
  );
};
